// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d8e31bb5","234":"4da93648","415":"76b93fa2"}[chunkId] + ".chunk.js";
};